<template>
  <FluxoCompletoComponent :category="2" :title="'Fluxo Completo Uniformes'" />
</template>

<script>
import FluxoCompletoComponent from "../components/FluxoCompletoComponent.vue";
export default {
  components: {
    FluxoCompletoComponent,
  },
};
</script>

<style></style>
